<template>
<div class="page bd">
  <toobarhead :showRefresh="false" :showBack="true" :titleName="'审批详情'"></toobarhead>
  <div class="ui_floor">
       <div id="stock-log-timeline" class="cd-container">
       <p v-show="this.contract!=-1" align="center">合同流程</p>
       <br v-show="this.contract!=-1">
        <div class="cd-timeline-block" v-for="(row, index) in logList" v-show="row.group=='合同流程'">
          <div v-bind:class="['cd-timeline-img',(index == 0) ? 'cd-even' : 'cd-odd']"></div>
            <div class="cd-timeline-content">
              <p>【{{ row.group }}】-【{{row.flowActionLabel}}】</p>
              <p> 操作人：{{row.userName}} </p>
              <p v-show="row.resultLabel && row.resultLabel.length > 0">审核结果：{{row.resultLabel}}</p>
              <p v-show="row.taskName && row.taskName=='legal'">{{legal(row)}}</p>
              <p>{{row.createTime}}</p>
              <p>详情：</p>
              <p v-show="row.comment && row.comment.length > 0" v-html="row.comment"></p>
          </div>
        </div>
        <p v-show="this.seal!=-1" align="center">其他盖章流程</p>
        <br v-show="this.seal!=-1">
        <div class="cd-timeline-block" v-for="(row, index) in logList" v-show="row.group=='其他盖章流程'">
          <div v-bind:class="['cd-timeline-img',(index == 0) ? 'cd-even' : 'cd-odd']"></div>
            <div class="cd-timeline-content">
              <p>【{{ row.group }}】-【{{row.flowActionLabel}}】</p>
              <p> 操作人：{{row.userName}} </p>
              <p v-show="row.resultLabel && row.resultLabel.length > 0">审核结果：{{row.resultLabel}}</p>
              <p v-show="row.taskName && row.taskName=='legal'">{{legal(row)}}</p>
              <p>{{row.createTime}}</p>
              <p>详情：</p>
              <p v-show="row.comment && row.comment.length > 0" v-html="row.comment"></p>
          </div>
        </div>
        <p v-show="this.reClassify!=-1" align="center">重新归档流程</p>
        <br v-show="this.reClassify!=-1">
        <div class="cd-timeline-block" v-for="(row, index) in logList" v-show="row.group=='重新归档流程'">
          <div v-bind:class="['cd-timeline-img',(index == 0) ? 'cd-even' : 'cd-odd']"></div>
            <div class="cd-timeline-content">
              <p>【{{ row.group }}】-【{{row.flowActionLabel}}】</p>
              <p> 操作人：{{row.userName}} </p>
              <p v-show="row.resultLabel && row.resultLabel.length > 0">审核结果：{{row.resultLabel}}</p>
              <p v-show="row.taskName && row.taskName=='legal'">{{legal(row)}}</p>
              <p>{{row.createTime}}</p>
              <p>详情：</p>
              <p v-show="row.comment && row.comment.length > 0" v-html="row.comment"></p>
          </div>
        </div>
        <p v-show="this.abolish!=-1" align="center">废除合同流程</p>
        <br v-show="this.abolish!=-1">
        <div class="cd-timeline-block" v-for="(row, index) in logList" v-show="row.group=='废除合同流程'">
          <div v-bind:class="['cd-timeline-img',(index == 0) ? 'cd-even' : 'cd-odd']"></div>
            <div class="cd-timeline-content">
              <p>【{{ row.group }}】-【{{row.flowActionLabel}}】</p>
              <p> 操作人：{{row.userName}} </p>
              <p v-show="row.resultLabel && row.resultLabel.length > 0">审核结果：{{row.resultLabel}}</p>
              <p v-show="row.taskName && row.taskName=='legal'">{{legal(row)}}</p>
              <p>{{row.createTime}}</p>
              <p>详情：</p>
              <p v-show="row.comment && row.comment.length > 0" v-html="row.comment"></p>
          </div>
        </div>
      </div>
  </div>
</div>
</template>
<script>
  import toobarhead from './head'
  export default {
    data () {
      return {
        logList: [],
        risk: 0,
        contract: -1,
        seal: -1,
        abolish: -1,
        reClassify: -1
      }
    },
    mounted: function () {
      let route = this.$route
      let vm = this
      this.$http.get('rest/api/auditLog?contractId=' + route.params.contractId).then(function (response) {
        vm.logList = response.data.reverse()
        this.contract = JSON.stringify(vm.logList).indexOf('"合同流程"')
        this.reClassify = JSON.stringify(vm.logList).indexOf('"重新归档流程"')
        this.seal = JSON.stringify(vm.logList).indexOf('"其他盖章流程"')
        this.abolish = JSON.stringify(vm.logList).indexOf('"废除合同流程"')
        vm.risk = route.query.risk
      }, function (response) {
        this.showLoading = false
        window.alert('失败')
      })
    },
    methods: {
      legal (row) {
        if (row.taskName && row.taskName === 'legal' && this.risk > 0) { // 风险提示
          if (this.risk === 1) {
            return '法务风险提示：一般、较大风险'
          } else if (this.risk === 2) {
            return '法务风险提示:重大风险'
          }
          return ''
        }
      }
    },
    components: {
      toobarhead
    }
  }
</script>
<style>
  .detail {
    text-align: left;
    padding-right: 0px
  }
  .middle {
    height: 4px;
    background-color: #f1f1f1
  }
  .bd{
    background-color: #f1f1f1;
    padding-bottom: 20px;
    height: 90%
  }
  .ui_floor{width: 100%; display: inline-block; border-top: 1px solid #eee; border-bottom: 1px solid #eee; margin: 5px auto;}
  .cd-container { width: 100%; margin: 0 auto;}
  .cd-container::after {content: ''; display: table; clear: both;}
  .cd-timeline-block {position: relative; margin: 1em 0;}
  .cd-timeline-block:after {content: ""; display: table; clear: both;}
  .cd-timeline-block:first-child {margin-top: 0;}
  .cd-timeline-block:last-child {margin-bottom: 0;}
  .cd-timeline-img.cd-even {background: #0c9145; box-shadow: 0 0 0 2px #fff;}
  .cd-timeline-img.cd-odd {background: #d5d5d5;}
  .cd-timeline-img {position: absolute;top: 0;left: 15px; width: 10px; height: 10px; border-radius: 50%;}
  .cd-timeline-content {position: relative; margin-left: 40px; margin-right: 14px; background: white; border-radius: 0.25em; padding: 0.5em 1em; box-shadow: 0 3px 0 #d7e4ed; top: -16px;}
  .cd-timeline-content:after {content: ""; display: table; clear: both;}
  .cd-timeline-content::before {content: ''; position: absolute; top: 16px; right: 100%; height: 0; width: 0; border: 7px solid transparent; border-right: 7px solid white;}
  .cd-timeline-content p{font-size: 14px; color: #666;}
  .cd-timeline-block:first-child .cd-timeline-content p{color: #0c9145;}
  #stock-log-timeline {position: relative; padding: 2em 0; margin-bottom: 2em;}
  #stock-log-timeline::before {content: ''; position: absolute; top: 0; left: 18px; height: 100%; width: 4px; background: #d7e4ed;}
  .cd-timeline-content p{text-align: left; padding-left: 2px}
</style>



// WEBPACK FOOTER //
// log.vue?44cf95e7